import Centered from "./Centered";
import ErrorMessage from "./ErrorMessage";

export default function ErrorPage(_props: {}) {
  return (
    <Centered>
      <ErrorMessage
        errorMessage="Something went wrong"
        callToAction="Reload Page"
        onCallToActionClick={() => window.location.reload()}
      />
    </Centered>
  );
}
